import React, { Component } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom'

export class Modelpopup extends Component {
  constructor(props) {
    super(props);

  }

  render() {
    return (
      <Modal
      {...this.props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Attention !!
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        { process.env.PUBLIC_URL === '/imarkdemo' ? <React.Fragment>
          <h5>The dashboard has been updated with a new look and feel!</h5>
          <h5>All dashboard functionality remains the same, along with a few new upgrades!</h5>
          <p>If you are experiencing issues with viewing the dashboard data, please try clearing your browsing data and log back in!</p>
          <ul>
            <li>108710 - Mountainland Supply Co,LLC</li>
            <li>229700 - Coastal Supply Group</li>
            <li>43600002 - Watts Water Technologies</li>
            <li>45100002 - Sloan Valve Company</li>
          </ul>
        </React.Fragment> : <React.Fragment>
           To unlock all capabilities of your dashboard and learn how to get onboarded,
          <br /> please schedule a meeting with a team member here:
         <h5><a href="https://calendly.com/imark-dashboard-project" target='_blank'>calendly.com/imark-dashboard-project</a></h5>
        </React.Fragment> }
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={this.props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
    );
  }
}

export default Modelpopup;
